import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { noWhitespaceValidator } from '@piqet-angular/data';
import { CustomModalService } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-add-role',
  templateUrl: './add-role.component.html',
  styleUrls: ['./add-role.component.scss'],
})
export class AddRoleComponent {
  modalLabel: any;
  adminRoleData: any;
  roleAddForm!: FormGroup;
  submitted = false;
  activatedRoute: any;
  @Output() saveRoleEvent = new EventEmitter<any>();

  constructor(private modal: CustomModalService, private formBuilder: FormBuilder) {
    this.adminRoleData = this.modal?.modalService?.config?.initialState?.['roleData'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
  }

  ngOnInit(): void {
    this.roleAddForm = this.formBuilder.group({
      role: ['', [Validators.required, noWhitespaceValidator]],
    });
  }

  onSave() {
    this.submitted = true;
    if (this.roleAddForm.valid && this.roleAddForm.controls['role'].value.trim() !== '') {
      const rolePayload = {
        rolename: this.roleAddForm.controls['role'].value.trim(),
      };
      this.saveRoleEvent.emit(rolePayload);
      this.submitted = false;
    }
  }

  onClose() {
    this.modal.close();
  }
}
